export const MAX_UPLOAD_SIZE_TYPES = {
  default: 10,
  exceptional: 25,
};
